module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_waso_location-7b9150be6e5d08a318a613e2df042c86.webp";